import { render, staticRenderFns } from "./ShipTable.vue?vue&type=template&id=36a31331&scoped=true&"
import script from "./ShipTable.vue?vue&type=script&lang=js&"
export * from "./ShipTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipTable.vue?vue&type=style&index=0&id=36a31331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a31331",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VTextField})
